/**
 * Utilities for detecting and handling brand permission errors (cross-brand access messaging).
 *
 * Scenario 1: User is truly unauthenticated (no cookie) - show existing "Please Sign In" message.
 * Scenario 2: User is authenticated on another brand but not allowed on current brand -
 *             show "brand access denied" message.
 */

/** SubCode returned by backend when user is authenticated but not allowed for current website */
export const BRAND_PERMISSION_SUBCODE = "AccountServiceUserNotAllowedForWebsite";

/**
 * Checks if the session indicates a cross-brand authenticated state.
 * This means the user has a valid auth cookie (logged in on another brand)
 * but is not permitted on the current website/brand.
 */
export function isCrossBrandAuthenticated(sessionProperties?: { [key: string]: string }): boolean {
    return sessionProperties?.isCrossBrandAuthenticated === "true";
}

/**
 * Checks if an API error response indicates a brand permission denial.
 * Used for detecting Scenario 2 errors from cart/wishlist API calls.
 */
export function isBrandPermissionError(errorJson?: { message?: string; subCode?: string }): boolean {
    return errorJson?.subCode === BRAND_PERMISSION_SUBCODE;
}

/** Temporary message for brand access denied (to be replaced with CMS message from Winnie) */
export const BRAND_ACCESS_DENIED_MESSAGE =
    "You are signed in but do not have access to this brand. Please contact customer support to request access.";
